import { Link } from "react-router-dom";
import { SectionEyebrow, SectionTitle, FadeUp } from "./_shared";
import GoldFoilFrame from "./GoldFoilFrame";
import { TEAM } from "./Team";

const ONE_LINERS = {
  "john-campetella": "Architect of the Unified Medical Model and the Integrated Matrix Engine.",
  "michael-ellis": "Internal medicine physician leading clinical oversight across every program.",
  "michael-fullen": "Enterprise CIO overseeing security architecture and data protection.",
  "giovanni-boiano": "Implant & cosmetic dentistry — FAGD, FICOI.",
  "christina-decicco": "Board-certified family NP grounding programs in day-to-day clinical practice.",
};

export default function TeamCompact() {
  return (
    <section
      id="team"
      data-testid="team-compact-section"
      className="py-24 md:py-32 bg-background"
    >
      <div className="max-w-6xl mx-auto px-4 md:px-8">
        <FadeUp className="text-center max-w-2xl mx-auto">
          <SectionEyebrow>Leadership &amp; Clinical Team</SectionEyebrow>
          <SectionTitle className="mt-4 text-[clamp(1.9rem,4.5vw,3.25rem)]">
            The people behind <em className="not-italic text-primary">your care</em>.
          </SectionTitle>
        </FadeUp>

        <div className="mt-14 grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-x-5 gap-y-10">
          {TEAM.map((person, i) => (
            <FadeUp key={person.id} delay={i * 0.06} className="text-center">
              <div data-testid={`team-compact-${person.id}`}>
                <div className="flex justify-center">
                  <GoldFoilFrame rounded="full" inset={3}>
                    <img
                      src={person.image}
                      alt={`${person.name} — Integrated Wellness`}
                      className="h-24 w-24 md:h-28 md:w-28 rounded-full object-cover bg-card block"
                      loading="lazy"
                    />
                  </GoldFoilFrame>
                </div>
                <div className="mt-4 font-display text-base font-bold text-primary leading-tight">
                  {person.name}
                </div>
                <div className="mt-1 font-mono text-[0.56rem] uppercase tracking-[0.18em] text-foreground/55">
                  {person.role}
                </div>
                <p className="mt-2.5 text-[0.8rem] text-foreground/65 leading-relaxed">
                  {ONE_LINERS[person.id]}
                </p>
              </div>
            </FadeUp>
          ))}
        </div>

        <FadeUp delay={0.25} className="mt-12 text-center">
          <Link
            to="/team"
            data-testid="meet-the-team-link"
            className="iw-btn-ghost inline-flex items-center gap-2 px-7 py-3.5 text-[0.68rem]"
          >
            Meet the Team <span aria-hidden>→</span>
          </Link>
        </FadeUp>
      </div>
    </section>
  );
}
